/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Toggle_Video_LockInputs */

const en_shortcut_keys_name_toggle_video_lock = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Video_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle Video Lock`)
};

const fr_shortcut_keys_name_toggle_video_lock = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Video_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basculer verrouillage video`)
};

const de_shortcut_keys_name_toggle_video_lock = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Video_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videosperre umschalten`)
};

const it_shortcut_keys_name_toggle_video_lock = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Video_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva/disattiva blocco video`)
};

const ru_shortcut_keys_name_toggle_video_lock = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Video_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переключить блокировку видео`)
};

const es_shortcut_keys_name_toggle_video_lock = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Video_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activar o desactivar el bloqueo de vídeo`)
};

const zh_cn2_shortcut_keys_name_toggle_video_lock = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Video_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换视频锁定`)
};

const ja_shortcut_keys_name_toggle_video_lock = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Video_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオロックの切り替え`)
};

const hi_shortcut_keys_name_toggle_video_lock = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Video_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो लॉक टॉगल करें`)
};

const pt_pt2_shortcut_keys_name_toggle_video_lock = /** @type {(inputs: Shortcut_Keys_Name_Toggle_Video_LockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar bloqueio de vídeo`)
};

/**
* | output |
* | --- |
* | "Toggle Video Lock" |
*
* @param {Shortcut_Keys_Name_Toggle_Video_LockInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_toggle_video_lock = /** @type {((inputs?: Shortcut_Keys_Name_Toggle_Video_LockInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Toggle_Video_LockInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_toggle_video_lock(inputs)
	if (locale === "de") return de_shortcut_keys_name_toggle_video_lock(inputs)
	if (locale === "it") return it_shortcut_keys_name_toggle_video_lock(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_toggle_video_lock(inputs)
	if (locale === "es") return es_shortcut_keys_name_toggle_video_lock(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_toggle_video_lock(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_toggle_video_lock(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_toggle_video_lock(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_toggle_video_lock(inputs)
	return en_shortcut_keys_name_toggle_video_lock(inputs)
});